<template>
    <div :class="['techKit reveal']">
        <div class="techGrid">
            <div class="kitDesc" > 
                <div v-html="componentData.content">
                </div>
            </div>
            <div class="kitImg">
                <img :src="'http://mis-implants.com/upload'+componentData.files[0].file_url"/>
            </div>
        </div>
    </div>
</template>

<style scoped>
    .techGrid
    {
        display: flex;
        flex-direction: row;            
        width: 80%;
        max-width: 1200px;
        margin: auto;
        column-gap: 20px;
        padding-top: 40px;
    }
    .kitDesc
    {
        text-align: left;
        display: flex;
        align-items: center;
        border: solid 0px red;
    }
    .kitImg
    {
        display: flex;
        align-items: center;        
        text-align: center;
    }
    .kitImg img
    {
        height: 30vw;
        width: auto;
        margin: auto;
    }

@media (max-width: 850px) 
{ 
    .techGrid
    {
        flex-direction: column-reverse;
        gap: 40px;
        padding-bottom: 40px;
        padding-top: 0px;
    }
    .kitImg img
    {
        height: 50vw;
    }

}

@media (max-width: 850px) and (orientation:landscape) {

}

  @media (hover: hover){
  }
</style>

<script>
    import { mapActions, mapState } from "vuex";
    import splitter from "@/views/com/splitter.vue";
    import sidepager from "@/views/com/sidepager.vue";
    import { splitLines,isMobileScreen }         from "@/utils";

    export default {
        components:{splitter,sidepager},
        props: 
        {
            sectionDataIndex:Number,
            openIndex:Number,
            componentData:Object
        },     
        mounted()
        {
        },
        destroyed() {
        },
        methods:
        {
        },
        data()
        {
            return {
                slideIndex:0,
                }
        },
        computed:
        {
        }        
    }
</script>  
